import { createReducer } from "reduxsauce";

import _ from "lodash";
import ReducerRegister from "../../../ReducerRegister";
import HomeworkDetailsService from "../../../../services/screens/admin/class/HomeworkDetailsService";
import { ActionTypes } from "../../../actionTypes/screens/admin/class/HomeworkDetailsActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import Constants from "../../../../config/Constants";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.class.homeworkdetails;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, searchVO });

            HomeworkDetailsService.loadScreenView(
                searchVO,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, searchVO) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        searchVO
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    searchStudentAsync: searchVO => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SEARCH_STUDENT_ASYNC, searchVO });

            HomeworkDetailsService.searchStudent(
                searchVO,
                response => {
                    dispatch(Actions.searchStudentSuccess(response, searchVO));
                },
                error => {
                    dispatch(Actions.searchStudentFailure(error));
                }
            );
        };
    },

    searchStudentSuccess: (data, searchVO) => ({
        type: ActionTypes.SEARCH_STUDENT_SUCCESS,
        parentType: ActionTypes.SEARCH_STUDENT_ASYNC,
        postReducer: searchStudentSuccessPostReducer,
        data,
        searchVO
    }),

    searchStudentFailure: error => ({
        type: ActionTypes.SEARCH_STUDENT_FAILURE,
        parentType: ActionTypes.SEARCH_STUDENT_ASYNC,
        error
    }),

    addOrDeleteCheck: i => ({
        type: ActionTypes.ADD_OR_DELETE_CHECK,
        i
    }),

    addAllCheck: i => ({
        type: ActionTypes.ADD_ALL_CHECK,
        i
    }),

    deleteAllCheck: () => ({
        type: ActionTypes.DELETE_ALL_CHECK
    }),

    sendReminderAsync: emailDetail => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SEND_REMINDER_ASYNC, emailDetail });

            HomeworkDetailsService.sendReminder(
                emailDetail,
                response => {
                    dispatch(Actions.sendReminderSuccess(response, emailDetail));
                },
                error => {
                    dispatch(Actions.sendReminderFailure(error));
                }
            );
        };
    },

    sendReminderSuccess: (data, emailDetail) => ({
        type: ActionTypes.SEND_REMINDER_SUCCESS,
        parentType: ActionTypes.SEND_REMINDER_ASYNC,
        postReducer: sendReminderSuccessPostReducer,
        data,
        emailDetail
    }),

    sendReminderFailure: error => ({
        type: ActionTypes.SEND_REMINDER_FAILURE,
        parentType: ActionTypes.SEND_REMINDER_ASYNC,
        error
    }),

};

//
// Initial State
//
const INITIAL_STATE = {
    homeworkDetail: null,
    students: null,
    pageCount: 0,
    totalCount: 0,
    selectedId: [],
    searchVO: {
        pageIndex: 1,
        pageSize: Constants.DefaultPageSize,
        tabIndex: 0
    },
    sendEmailDetail: {
        subject: "",
        to: "",
        cc: "",
        content: ""
    }
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, searchVO }) => {
    return { ...state,
        searchVO,
        homeworkDetail: data.homeworkDetail,
    };
};

const searchStudentSuccessPostReducer = (state, { data, searchVO }) => {
    return { ...state,
        students: data.pagedStudent.studentList,
        searchVO,
        pageCount: data.pagedStudent.pageCount,
        totalCount: data.pagedStudent.totalCount,
        selectedId: [],
    };
};

const addOrDeleteCheckReducer = (state, { i }) => {
    const { selectedId } = state;
    let newSelectedId = _.clone(selectedId);
    if (newSelectedId.includes(i)) {
        for (let j = 0 ; j < newSelectedId.length; j ++) {
            if (newSelectedId[j] === i) {
                newSelectedId.splice(j, 1);
            }
        }
    } else {
        newSelectedId.push(i);
    }

    return { 
        ...state,
        selectedId: newSelectedId, 
    };
};

const addAllCheckReducer = (state, { i }) => {
    const { selectedId } = state;
    let newSelectedId = _.clone(selectedId);
    if (!newSelectedId.includes(i)) {
        newSelectedId.push(i);
    }

    return { 
        ...state,
        selectedId: newSelectedId, 
    };
};

const deleteAllCheckReducer = (state) => {
    return { 
        ...state,
        selectedId: [], 
    };
};

const sendReminderSuccessPostReducer = (state, { data, emailDetail }) => {
    return { ...state,
        sendEmailDetail: emailDetail
    };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SEARCH_STUDENT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEARCH_STUDENT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEARCH_STUDENT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.ADD_OR_DELETE_CHECK]: addOrDeleteCheckReducer,
    [ActionTypes.ADD_ALL_CHECK]: addAllCheckReducer,
    [ActionTypes.DELETE_ALL_CHECK]: deleteAllCheckReducer,
    [ActionTypes.SEND_REMINDER_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEND_REMINDER_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEND_REMINDER_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
